import React, { PureComponent } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Spinner, Button } from 'reactstrap';
import EyeIcon from 'mdi-react/EyeIcon';
import KeyVariantIcon from 'mdi-react/KeyVariantIcon';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import PropTypes from 'prop-types';
import { resetUserPassword } from '../../../redux/actions/userActions';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import setPropsAsInitialValues from '../../../helpers/setPropsAsInitialValues';
import { createErrorMessage, createSuccessMessage } from '../../../helpers/notification';
import TextBox from '../../../shared/components/form/TextBox';
import Confirm from '../../../shared/components/Confirm';
import validateForm from './validate';

class LogIn extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    loggingIn: PropTypes.bool.isRequired,
  };

  constructor() {
    super();
    this.state = {
      showPassword: false,
      email: false,
      resetPassword: false,
    };
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  resetUserPassword = (props) => {
    const { valid } = props;
    if (!valid) {
      return;
    }

    const { email } = this.state;

    Confirm({
      title: 'Restablecer contrase\xF1a',
      question: `Est\xE1s seguro que deseas restablecer la contrase\xF1a de ${email}?`,
      yesLabel: 'Si, Restablecer',
      noLabel: 'No, Volver',
      onConfirm: () => {
        resetUserPassword(email, {
          onSuccess: () => {
            const msg = 'Contrase\xF1a restablecida exitosamente.';
            createSuccessMessage(`${msg} Se ha enviado un correo con la contrase\xF1a temporal.`);
            this.setState({ resetPassword: false });
          },
          onError: (error) => {
            if (error && error.status === 404) {
              createErrorMessage('El usuario no existe');
            } else {
              createErrorMessage('Error al intentar restablecer contrase\xF1a');
            }
          },
        });
      },
    });
  };

  handleSubmit = (values) => {
    const { handleSubmit } = this.props;
    return handleSubmit(values);
  }

  showSpinner = () => (
    <div className="form__form-group text-center">
      <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
    </div>
  );

  showLoging = (showPassword, submitting, pristine) => (
    <>
      <div className="form__form-group">
        <span className="form__form-group-label">Usuario</span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <AccountOutlineIcon />
          </div>
          <Field
            name="email"
            component={TextBox}
            type="text"
            placeholder="Email"
            onChange={this.handleChange}
          />
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">Contrase&ntilde;a</span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <KeyVariantIcon />
          </div>
          <Field
            name="password"
            component={TextBox}
            type={showPassword ? 'text' : 'password'}
            placeholder="Contrasena"
          />
          <button
            className={`form__form-group-button${showPassword ? ' active' : ''}`}
            onClick={e => this.showPassword(e)}
            type="button"
          ><EyeIcon />
          </button>
        </div>
      </div>
      <div className="form__form-group d-none">
        <div className="form__form-group-field">
          <Field
            name="remember_me"
            component={renderCheckBoxField}
            label="Recuerdame"
          />
        </div>
      </div>
      <button
        type="submit"
        className="btn btn-primary account__btn account__btn--small"
        disabled={pristine || submitting}
      >Ingresar
      </button>
      <Button
        color="link"
        size="sm"
        onClick={() => this.setState({ resetPassword: true })}
      >
        <i className="fa fa-unlock-alt" aria-hidden="true" /> &iquest;Olvidaste tu Contrase&ntilde;a?
      </Button>
    </>
  );

  showResetPassword = () => (
    <>
      <div className="form__form-group">
        <span className="form__form-group-label">Usuario</span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <AccountOutlineIcon />
          </div>
          <Field
            name="email"
            component={TextBox}
            type="text"
            placeholder="Email"
            onChange={this.handleChange}
          />
        </div>
      </div>
      <div className="form__form-group d-none">
        <div className="form__form-group-field">
          <Field
            name="remember_me"
            component={renderCheckBoxField}
            label="Recuerdame"
          />
        </div>
      </div>
      <button
        type="button"
        className="btn btn-primary"
        onClick={() => this.resetUserPassword(this.props)}
      >Restablecer
      </button>
      <Button
        color="secondary"
        size="sm"
        onClick={() => this.setState({ resetPassword: false })}
      >Cancelar
      </Button>
    </>
  );

  render() {
    const { showPassword, resetPassword } = this.state;
    const { submitting, pristine, loggingIn } = this.props;

    if (resetPassword) {
      return (
        <form className="form" onSubmit={values => this.handleSubmit(values)}>
          {
            this.showResetPassword()
          }
        </form>
      );
    }

    return (
      <form className="form" onSubmit={values => this.handleSubmit(values)}>
        {
          !loggingIn ? this.showLoging(showPassword) : this.showSpinner(submitting, pristine)
        }
      </form>
    );
  }
}

const LogInForm = reduxForm({
  form: 'LogInForm',
  validate: validateForm,
})(LogIn);

export default setPropsAsInitialValues(LogInForm);
